import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/mdi-delete.svg'


const _hoisted_1 = {
  class: "chat-container",
  ref: "chatContainer"
}
const _hoisted_2 = {
  key: 0,
  style: {"margin-top":"1rem","text-align":"center","opacity":"0.5"}
}
const _hoisted_3 = { class: "input-container" }
const _hoisted_4 = { class: "input-area-wrapper" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "몰?루화 내역 삭제"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["disabled", "placeholder", "maxlength"]
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChatItem = _resolveComponent("ChatItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.chats.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "몰?루화한 문장 내역이 여기에 표시됩니다."))
        : _createCommentVNode("", true),
      _createVNode(_TransitionGroup, { name: "slide-up" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chats, (chat) => {
            return (_openBlock(), _createBlock(_component_ChatItem, {
              key: chat.hash,
              chatData: chat
            }, null, 8, ["chatData"]))
          }), 128))
        ]),
        _: 1
      })
    ], 512),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          title: "채팅 내역 비우기",
          disabled: _ctx.mollufyDisabled,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearChats && _ctx.clearChats(...args)))
        }, _hoisted_7, 8, _hoisted_5),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sentenceToMollu) = $event)),
          onKeydown: [
            _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.doMollufy && _ctx.doMollufy(...args)), ["exact"]), ["enter"])),
            _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.doMollufy && _ctx.doMollufy(...args)), ["ctrl","exact"]), ["enter"]))
          ],
          disabled: _ctx.mollufyDisabled,
          type: "text",
          placeholder: '몰?루화할 문장 입력... (최대 ' + _ctx.TEXT_LENGTH_LIMIT.toLocaleString() + '자)',
          maxlength: _ctx.TEXT_LENGTH_LIMIT,
          autofocus: ""
        }, null, 40, _hoisted_8), [
          [_vModelText, _ctx.sentenceToMollu]
        ])
      ]),
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.doMollufy && _ctx.doMollufy(...args))),
        disabled: _ctx.mollufyDisabled
      }, "몰?루화!", 8, _hoisted_9)
    ])
  ], 64))
}